export const NaurEventStatus = {
  OPEN: 'OPEN',
  PENDING_APPLICANT: 'PENDING_APPLICANT',
  PENDING_CERTIFICATION: 'PENDING_CERTIFICATION',
  PENDING_MOVE_IN: 'PENDING_MOVE_IN',
  SATISFIED: 'SATISFIED',
};
